<template>
  <section id="trip" class="account-page section-show" style="height: auto!important;">
    <div class="container">
      <div v-if="authState.userData.username">

        <div class="section-title">
          <p>Учетная запись</p>
        </div>

        <div class="menu-container">
          <router-link :to="{ name: 'tripHistory' }" class="menu-item">История поездок</router-link>
          <router-link :to="{ name: 'bonuses' }" class="menu-item active">Бонусы</router-link>
          <router-link :to="{ name: 'settings' }" class="menu-item">Настройки</router-link>
        </div>

        <div class="account-page__content">
          <router-view/>
        </div>
      </div>
      <div v-else><h2>404</h2></div>
    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import authStore from "@/store/auth";

export default defineComponent({
  name: 'TripPageLayout',
  components: {},
  setup: function () {
    const {
      authState
    } = authStore

    return {
      authState
    }
  },
})
</script>
<style scoped>

.menu-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start; /* Выравниваем меню по левому краю */
  gap: 15px;
}

</style>
